/**
 * Zugriff auf das Branding. Reihenfolge:
 *   1. Werte, die das Backend zur Laufzeit liefert (erlaubt Umbenennen ohne Build)
 *   2. der zum Buildzeitpunkt eingebackene Wert aus branding.config.json
 *
 * In Komponenten IMMER site.name verwenden, nie den Namen literal schreiben.
 * scripts/check-branding.mjs prüft das.
 */

const buildTime = __BRANDING__;

let runtime = null;

export const site = {
  get name() {
    return runtime?.siteName ?? buildTime.siteName;
  },
  get nameShort() {
    return runtime?.siteNameShort ?? buildTime.siteNameShort;
  },
  get tagline() {
    return runtime?.tagline ?? buildTime.tagline;
  },
  get description() {
    return runtime?.description ?? buildTime.description;
  },
  get themeColor() {
    return runtime?.themeColor ?? buildTime.themeColor;
  },
  get locale() {
    return runtime?.locale ?? buildTime.locale;
  },
};

/** Einmal beim Start aufrufen. Faellt still auf die Buildwerte zurück. */
export async function loadBranding() {
  try {
    const res = await fetch('/api/branding.php');
    if (res.ok) {
      runtime = await res.json();
      document.title = site.name;
      document.documentElement.lang = (site.locale || 'de-DE').slice(0, 2);
    }
  } catch {
    // Backend nicht erreichbar — Buildwerte reichen.
  }
}
